export enum Operation {
  EQUALS = 'EQUALS',
  LIKE = 'LIKE',
}

export type OperationType = Operation;
